var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.html)}}),(_vm.found === false)?[_c('h3',[_vm._v("Page non trouvée")])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }